import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ContactUsService {
  private landingContentDisplayStatus: string = 'none';
  private opsBpsContentDisplayStatus: string = 'none';

  setDisplayStatusByPageType(pageType: string) {
    setTimeout(() => {
      this.landingContentDisplayStatus = 'none';
      this.opsBpsContentDisplayStatus = 'block';
  
      if (pageType === 'login') {
        this.landingContentDisplayStatus = 'block';
        this.opsBpsContentDisplayStatus = 'none';
      }
    });
  }  

  getLandingContentDisplayStatus() {
    return this.landingContentDisplayStatus;
  }  

  getOpsBpsContentDisplayStatus() {
    return this.opsBpsContentDisplayStatus;
  }  
}